import { render, staticRenderFns } from "./col_card.vue?vue&type=template&id=91ac4d4a&scoped=true"
import script from "./col_card.vue?vue&type=script&lang=js"
export * from "./col_card.vue?vue&type=script&lang=js"
import style0 from "./col_card.vue?vue&type=style&index=0&id=91ac4d4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ac4d4a",
  null
  
)

export default component.exports